import { Link } from "react-router-dom";

const stats = [
  { value: "5000+", label: "收录影视作品" },
  { value: "1200+", label: "影视资讯文章" },
  { value: "28", label: "覆盖国家与地区" },
  { value: "每日", label: "持续更新内容" },
];

export default function IntroBand() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 pt-10 md:px-8 md:pt-12">
      <div className="grid grid-cols-1 gap-6 rounded-lg bg-primary-950 p-6 md:p-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-800 px-3 py-1 text-xs font-medium text-secondary-300">
            <i className="ri-information-line"></i>
            关于 91影视
          </span>
          <h2 className="mt-4 text-2xl font-bold text-background-50 md:text-3xl">
            一个专注影视内容与资讯的门户平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-primary-200">
            91影视致力于为影视爱好者提供清晰、便捷的内容浏览体验。你可以按类型、地区、年份多维筛选影片，
            快速了解每部作品的导演、主演、剧情与评分，也能在资讯频道获取行业动态与影评推荐。
            <br />
            <br />
            我们坚持真实、克制的呈现方式：当前站点为信息展示平台，播放与下载功能尚未开放，所有内容均为演示数据。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-secondary-400"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-700 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-900"
            >
              开始浏览
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="rounded-lg bg-primary-900 p-5">
              <p className="text-2xl font-extrabold text-secondary-400 md:text-3xl">{stat.value}</p>
              <p className="mt-1 text-xs text-primary-200 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}